import { IsiControl } from "../Controls/IsiControl";
import { IsiComponentClientEventArgs } from "./IsiComponentClientEventArgs";
//import IsiComponentEvent = require("./IsiComponentEvent");
//import IsiComponentAjaxEvent = require("./IsiComponentAjaxEvent");
import { IsiRWDMode, IsiRWDLength } from "../../IsiFW.enums";
import { addParamToUrl, updateDtoProperty, IsiJsTools, stopPropagation, doPostBackAsync } from "../../../core.ts";
import { IsiComponentClientState } from "./IsiComponentClientState";
import { IIsiDtoComponentV4, SaveClientStateResponsibleValue, IsiDtoComponentClientState, IsiDtoComponentV4, IIsiDtoComponentClientState, StateModeValue } from "../../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";

/**
 * La configuration
 * @typedef {Object} IsiComponentSettings
 * @property {Boolean} autoLaunchReady Indique si le noyau lève automatiquement le ready du composant
 * @property {Boolean} motion Indique si les animations sont activées
*/

export class IsiComponentV4ClientEvents {
    stateLoading = "stateLoading";
    stateLoaded = "stateLoaded";
    stateCleared = "stateCleared";
}

/// <summary>
/// Classe IsiComponent.
/// </summary>
/// <history>
///		 <entry mat="ybru" date="02/07/2015" task="1017501">Ajout des propriétés liées au libellé du composant</entry>
/// <history
export class IsiComponentV4 extends IsiControl {

    clientEvents = new IsiComponentV4ClientEvents();

    static IsiComponentEnums = {
        ViewMode: {
            SmallScreen: 0,
            FullScreen: 1,
        },
        // <summary>
        // La position du label du composant
        // </summary>
        // <history>
        //      <entry mat="ybru" date="03/07/2015" task="1017501">Création</entry>
        //      <entry mat="LFEN" date="07/05/2019" task=""> Ajout de Inner pour le composant Select</entry>
        // </history>
        LabelPositionType: {
            // <summary>
            // Ne pas afficher de label
            // </summary>
            None: "None",
            // <summary>
            // Afficher le label au dessus du composant
            // </summary>
            Top: "Top",
            // <summary>
            // Afficher le label à gauche du composant
            // </summary>
            Left: "Left",
            // <summary>
            // Afficher le label en dessous du composant
            // </summary>
            Bottom: "Bottom",
            // <summary>
            // Afficher le label à droite du composantn
            // </summary>
            Right: "Right",
            /// <summary>
            /// Afficher le label dans le composant (select)
            /// </summary>
            Inner: "Inner"
        },
        // <summary>
        // Liste des modes de création du label d'un composant.
        // </summary>
        // <history>
        //      <entry mat="ybru" date="03/07/2015" task="1017501">Création</entry>
        // </history>
        LabelCreationModeType: {
            // <summary>
            // Le label sera créé côté serveur.
            // </summary>
            Server: "Server",
            // <summary>
            // Le label sera créé côté client
            // </summary>
            Client: "Client",
        }

    }

    disposedValue = false;

    _isInitialized = false;
    _initFn: string;
    extended = false;
    serverId = null;
    specificComponentSenderId = false;
    biologicParent = null;
    childs = [];
    childsId = {};
    childId = null;
    isFirstLoad = true;
    controlContainer = null;
    private dto: IIsiDtoComponentV4 = null;
    group = null;
    jQueryElement;
    jQueryParentElement;
    isReady = false;
    loadingElement = null;
    enableLoadingPanel = false;
    useProgressBar = false;
    showLoadingPanelOnLoad = false;
    errorOnLoad = false;
    childsFoundHandlers = [];
    //GBAU - 03/11/2016 - RWD DEV127803
    childsInitializedHandlers = [];
    childsReadyHandlers = [];
    viewUpdatingForcedForEvents = null;
    wrapper = this;
    ajaxLoad = false;
    ajaxLoaded = false;
    ajaxLoadFunc = Function();
    useController = false;
    activateClientResize = false;
    enableClientDrag = false;
    //[GBAU] 18/01/2012 Created - DYSF46334
    enableUserAction = true;
    //[GBAU] 18/01/2012 Created - DYSF46334
    enableToolbar = true;
    isResizedByClient = false;
    attachedComponents = null;
    ap = null;
    enableViewUpdatingEvent = true;
    useParentLoadingPanel = false;
    _instanceType;

    //GBAU - 12/11/2012 - DEV58282
    nbChild = 0;
    nbChildFound = 0;

    manualLoad = false;

    //GBAU - 28/11/2012 - DEV58867
    _viewMode = false;

    _initialSmallScreenWidth = null;
    _initialSmallScreenHeight = null;

    //GBAU - 26/12/2012
    readOnly = false;

    // Gestion des libellés
    label;
    labelPosition = window.IsiFW.IsiComponent.Enums.LabelPositionType.None;
    labelCreationMode = window.IsiFW.IsiComponent.Enums.LabelCreationModeType.Server;
    labelCssClass = "";

    events = {};

    _perfCounters = {};

    //Contient les traductions (messages) du composant
    _translations;

    /**
     * Booléen indiquant si les animations sont activées
     */
    _motion = true;

    _motionOptions: any;

    /**
     * Etat du composant
     */
    _state: IsiComponentClientState<IsiDtoComponentClientState>;

    _header;

    enablePostData = true;

    // MBRO - 15/02/2018 - DEV138958 - Gestion des booléens indiquant si le composant affiche un header et|ou un footer
    showHeader = true;
    showFooter = true;

    _showLoadingTimeout = null;
    _canHideLoading = true;

    /**
         * @var IsiComponentSettings
         */
    _settings = {
        autoLaunchReady: true,
        motion: uiCore.componentManager.isMotionIsEnabled(),
        /**
         * Indique la durée minimum d'affichage du panel de chargement
         * lors du raffraichissement d'un webpart.
         * Renseigner une valeur supérieure à 0.
         */
        showLoadingOnRefreshWebpartMinDuration: 0
    };

    // MBRO - 25/09/2018 - Dysf 84180 - Sauvegarde le scroll vertical (affichage popin)
    _scrollTop = null;
    controller = null;
    ClientEventsHandlers = null;
    activateClientDrag = null;
    progressBar = null;
    httpHandlerUrl = "";
    control = null;
    private parent: any;
    private parentId: string;

    /**
     * Nom de la classe est notamment ajouter aux classes css de l'element root du composant
     */
    public static clsName = "IsiComponentV4"

    constructor(element) {
        super(element);
        this.disposedValue = false;

        this._isInitialized = false;
        this._initFn = "";
        this.extended = false;
        this.serverId = null;
        this.specificComponentSenderId = false;
        this.biologicParent = null;
        this.childs = [];
        this.childsId = {};
        this.childId = null;
        this.isFirstLoad = true;
        this.controlContainer = null;
        this.dto = null;
        this.group = null;
        this.jQueryElement;
        this.jQueryParentElement;
        this.isReady = false;
        this.loadingElement = null;
        this.enableLoadingPanel = false;
        this.useProgressBar = false;
        this.showLoadingPanelOnLoad = false;
        this.errorOnLoad = false;
        this.childsFoundHandlers = [];
        //GBAU - 03/11/2016 - RWD DEV127803
        this.childsInitializedHandlers = [];
        this.childsReadyHandlers = [];
        this.viewUpdatingForcedForEvents = null;
        this.wrapper = this;
        this.ajaxLoad = false;
        this.ajaxLoaded = false;
        this.ajaxLoadFunc = null;
        this.useController = false;
        this.activateClientResize = false;
        this.enableClientDrag = false;
        //[GBAU] 18/01/2012 Created - DYSF46334
        this.enableUserAction = true;
        //[GBAU] 18/01/2012 Created - DYSF46334
        this.enableToolbar = true;
        this.isResizedByClient = false;
        this.attachedComponents = null;
        this.ap = null;
        this.enableViewUpdatingEvent = true;
        this.useParentLoadingPanel = false;
        this._instanceType;

        //GBAU - 12/11/2012 - DEV58282
        this.nbChild = 0;
        this.nbChildFound = 0;

        this.manualLoad = false;

        //GBAU - 28/11/2012 - DEV58867
        this._viewMode = false;

        this._initialSmallScreenWidth = null;
        this._initialSmallScreenHeight = null;

        //GBAU - 26/12/2012
        this.readOnly = false;

        // Gestion des libellés
        this.label;
        this.labelPosition = window.IsiFW.IsiComponent.Enums.LabelPositionType.None;
        this.labelCreationMode = window.IsiFW.IsiComponent.Enums.LabelCreationModeType.Server;
        this.labelCssClass = "";

        this.events = {};

        this._perfCounters = {};

        //Contient les traductions (messages) du composant
        this._translations;

        /**
         * Booléen indiquant si les animations sont activées
         */
        this._motion = true;

        this._motionOptions = false;

        this._header;

        this.enablePostData = true;

        // MBRO - 15/02/2018 - DEV138958 - Gestion des booléens indiquant si le composant affiche un header et|ou un footer
        this.showHeader = true;
        this.showFooter = true;

        this._showLoadingTimeout = null;
        this._canHideLoading = true;

        /**
         * @var IsiComponentSettings
         */
        this._settings = {
            autoLaunchReady: true,
            motion: uiCore.componentManager.isMotionIsEnabled(),
            /**
             * Indique la durée minimum d'affichage du panel de chargement
             * lors du raffraichissement d'un webpart.
             * Renseigner une valeur supérieure à 0.
             */
            showLoadingOnRefreshWebpartMinDuration: 0
        };

        // MBRO - 25/09/2018 - Dysf 84180 - Sauvegarde le scroll vertical (affichage popin)
        this._scrollTop = null;
    }



    private _stateLoading() {
        this.raiseEvent(this.clientEvents.stateLoading, {});
    }

    addStateLoading(handler: (component: this) => void) {
        this.get_events().addHandler(this.clientEvents.stateLoading, handler);
    }

    removeStateLoading(handler: (component: this) => void) {
        this.get_events().removeHandler(this.clientEvents.stateLoading, handler);
    }

    private _stateLoaded() {
        this.raiseEvent(this.clientEvents.stateLoaded, {});
    }

    addStateLoaded(handler: (sender: this) => void) {
        this.get_events().addHandler(this.clientEvents.stateLoaded, handler);
    }

    removeStateLoaded(handler: (sender: this) => void) {
        this.get_events().removeHandler(this.clientEvents.stateLoaded, handler);
    }

    private _stateCleared() {
        this.raiseEvent(this.clientEvents.stateCleared, {});
    }

    addStateCleared(handler: (sender: this) => void) {
        this.get_events().addHandler(this.clientEvents.stateCleared, handler);
    }

    removeStateCleared(handler: (sender: this) => void) {
        this.get_events().removeHandler(this.clientEvents.stateCleared, handler);
    }

    /**
    * Initialisation du composant
    */
    initialize() {

        //GBAU - 30/10/2015 - DEV113702 - Ajout d'un mécanisme de fonction d'initialisation pour les nouveaux composants (V3)
        if (this.get_InitFn()) {
            if (typeof (window[this.get_InitFn()]) !== 'undefined') {
                window[this.get_InitFn()](this);

                if (this.get_Dto()) {
                    this.get_Dto().__type = this._getDtoTypeOverridable();
                }
            }
        }

        //console.log("Initialize" + this.get_id());

        uiCore.componentManager.registerComponent(this);

        //GBAU - 13/04/2018 - DEV141524
        this._configure();


        if (this.childId != null && this.get_ParentId() != null) {
            if (this.get_parent() && this.get_parent() instanceof IsiComponentV4) {
                this.get_parent().registerChild(this);
            } else {
                uiCore.componentManager.whenComponentInitialized(this.get_ParentId(), (cp) => {
                    cp.registerChild(this)
                });
            }
        }

        if (this.get_UseController()) {
            uiCore.componentManager.whenControllerFound((controller) => {
                controller.ready(() => {
                    controller.registerComponent(this);
                });
            });
        }

        if (this.get_ShowLoadingPanelOnLoad()) {
            this.showLoading(true);
        }

        //GBAU - 05/04/2018 - A faire avant _initializeOverridable car si on déclare des évènement AJAX, il faut avoir configurer le HttpHandler avant
        this._configureHttpHandlerOverridable();
        this._initializeOverridable();

        //GBAU - 07/07/2016 - DEV124087
        this._onInitialized(this, {});


        //GBAU - 30/10/2018 : Lorsu'un composant fils est en chargement manuel, il s'enregistrait uniquement au moment de son firstLoad hors au niveau MasterPortal
        //il est nécessaire que chaque portail fils s'enregistre au moment de l'initialisation
        if (this.childId != null && this.biologicParent != undefined) {
            uiCore.componentManager.whenComponentFound(this.biologicParent, function (me) {
                return function (cp) {
                    me.biologicParent = cp;
                    if (me.biologicParent instanceof IsiComponentV4) {
                        me.biologicParent.registerChild(me);
                    }
                }
            }(this));
        }

        if (!this.get_ML()) {
            this.runLoad();
        }

    }
    _initializeOverridable() {

    }
    _configure() {
        this._settings = jQuery.extend(this._settings, this._configureOverridable());
    }
    /**
     * Obtient l'objet de configuration du composant
     * @returns {IsiComponentSettings}
     */
    _configureOverridable() {
        return {};
    }
    get_ParentId() {
        return this.parentId;
    }
    set_ParentId(value) {
        this.parentId = value;
    }
    get_parent() {
        if (this.parent == null && this.get_ParentId()) {
            this.parent = uiCore.componentManager.getComponent(this.get_ParentId());
        }
        return this.parent;
    }
    _getTranslationFamilyOverridable() {
        return ""
    }
    _getDummiesTranslation() {
        var dummiesTranslation;

        dummiesTranslation = this._getDummiesTranslationOverridable();

        return dummiesTranslation;
    }
    _getDummiesTranslationOverridable() {
        // A surcharger dans le composant.
        // Cela permet d'éviter les erreurs de ressources dans les pages de test.
    }
    _getAutoLaunchReadyOverridable() {
        return this._settings.autoLaunchReady;
    }
    /**
     * Indique si le composant gère un état coté client (localStorage)
     * @returns boolean
     */
    useClientState() {
        return this._useClientStateOverridable();
    }
    /**
     * Méthode à surcharger au niveau d'un composant pour retourner true dans le cas ou le composant souhaite géré un état
     * @returns boolean
     */
    _useClientStateOverridable() {
        return this.getDto().saveClientState;
    }
    runLoad() {
        var args = { launchReady: true };
        var needAjaxLoad = this.get_AjaxLoad();

        if (needAjaxLoad) {
            args.launchReady = false;
        }

        if (this.isFirstLoad) {
            this._onFirstLoad(this, args);
        }

        if (this.labelPosition != window.IsiFW.IsiComponent.Enums.LabelPositionType.None &&
            this.labelCreationMode == window.IsiFW.IsiComponent.Enums.LabelCreationModeType.Client) {

            var cssClass = "AutomaticLabel AutomaticLabel" + this.labelPosition
            var labelControl = '<span class="' + cssClass + " " + (this.labelCssClass || "") + '">' + this.label + '</span>';
            switch (this.labelPosition) {
                case window.IsiFW.IsiComponent.Enums.LabelPositionType.Top:
                case window.IsiFW.IsiComponent.Enums.LabelPositionType.Left:
                    this.getJQueryElement().prepend(labelControl);
                    break;
                case window.IsiFW.IsiComponent.Enums.LabelPositionType.Bottom:
                case window.IsiFW.IsiComponent.Enums.LabelPositionType.Right:
                    this.getJQueryElement().append(labelControl);
                    break;
            }
        }

        this._onLoad(this, args);

        if (this.get_ShowLoadingPanelOnLoad()) {
            this.showLoading(false);
        }
    }
    dispose() {
        this._beforeCoreDisposeOverridable();

        if (uiCore.componentManager) {
            uiCore.componentManager.disposeComponent(this);
        }

        //GBAU - 27/03/2012 - DYSF48686 : Rajout du test
        if (!this.disposedValue) {
            //GBAU - 02/10/2012 - DYSF52384
            // release the handlers
            this.clearMyHandlers();
            this.disposedValue = true;
        }

        this.biologicParent = null;
        this.childs = null;
        this.childsId = null;
        this.controlContainer = null;
        this.dto = null;
        this.group = null
        this.jQueryElement = null;
        this.jQueryParentElement = null;
        this.loadingElement = null;
        this.childsFoundHandlers = null;
        this.childsReadyHandlers = null;
        this.wrapper = null;
        this.attachedComponents = null;
        this.ap = null;
        this.events = null; //LRAT-GBAU - 26/03/2014 : Gestion évènements ajax

        // call to the base to do its dispose
        super.dispose()
        this._afterCoreDisposeOverridable();

        this._disposeOverridable();
    }

    get componentFactory() {
        return uiCore.componentFactory;
    }

    _beforeCoreDisposeOverridable() {
    }
    _afterCoreDisposeOverridable() {
    }
    _disposeOverridable() {
    }
    destroy() {
        var jElement = this.getJQueryElement();
        this.dispose();
        jElement.remove();
    }
    getSpecificComponentSenderId() {
        return this.specificComponentSenderId;
    }
    setSpecificComponentSenderId(value) {
        this.specificComponentSenderId = value;
    }
    clearMyHandlers() {
        //GBAU - 02/10/2012 - DYSF52384 : Permet de nettoyer les handlers de l'élément
        //$clearHandlers(this.get_element());

        if (this.get_EnableClientResize() && this.getJQueryElement().resizable("instance")) {
            this.getJQueryElement().resizable("destroy");
            this.getJQueryElement().unbind();
        }

        if (this.get_EnableClientDrag() && this.getJQueryElement().draggable("instance")) {
            this.getJQueryElement().draggable("destroy");
            this.getJQueryElement().unbind();
        }
        this.getJQueryElement().unbind();
        this.clearMySpecificHandlers();
    }
    clearMySpecificHandlers() {
        //GBAU - 02/10/2012 - DYSF52384 - Nettoyage spécifique
    }
    //#region EventHandler
    isInitialized() {
        //GBAU - 03/11/2016 - RWD DEV127803
        return this._isInitialized;
    }
    isLoaded() {
        return !this.isFirstLoad;
    }
    _onFirstLoad(sender, args) {
        if (this._getTranslationFamilyOverridable()) {
            //GBAU - 12/04/2016 - DEV113702 - On initialise les traductions
            this._translations = uiCore.componentManager.IsiGetTranslation(
                this._getTranslationFamilyOverridable(),
                function (me) {
                    return function () {
                        return me._getDummiesTranslation();
                    }
                }(this));
        }


        if (this.get_AjaxLoad()) {
            this.ajaxLoadFunc = function (me) {
                return function () {
                    if (me.get_AjaxLoad()) {
                        uiCore.componentManager.whenControllerFound(function (controller) {
                            controller.ready(function () {
                                if (me.get_AjaxLoad()) {
                                    me._launchAjaxLoad(sender, args);
                                }
                            });
                        });
                    }
                    if (!me.get_ML()) {
                        window.Sys.Application.remove_load(me.ajaxLoadFunc);
                    }
                    me.ajaxLoadFunc = null;
                }
            }(this);

            if (this.get_ML()) {
                this.ajaxLoadFunc();
            } else {
                window.Sys.Application.add_load(this.ajaxLoadFunc);
            }

        } //else {

        //Demande la déclaration des évènements
        this._declareEventsOverridable();

        if (this.useClientState()) {
            this._state = this._createInstanceOfStateOverridable();
            this._stateLoading();
            if (this.getDto().saveClientStateResponsible == SaveClientStateResponsibleValue.Himself) {
                this._loadStateHimself();
            }

        }

        this._RegisterClientEventsHandlers();

        this._bindHeaderEvents();

        this.onFirstLoad(sender, args);

        if (this.get_EnableClientResize()) {
            this.getJQueryElement().resizable(this._getResizableOptions());
        }

        if (this.get_EnableClientDrag()) {
            this.getJQueryElement().draggable(this._getDraggableOptions());
        }

        this.isFirstLoad = false;
        //}

        return !this.get_ErrorOnLoad();
    }
    onFirstLoad(sender, args) {

    }
    _onLoad(sender, args) {
        if (args.launchReady == undefined) {
            args.launchReady = true;
        }

        this.onLoad(sender, args);

        if (!this.isReady && args.launchReady && this._getAutoLaunchReadyOverridable()) {
            this._ready();
        }

        return !this.get_ErrorOnLoad();
    }
    onLoad(sender, args) {

    }
    _asyncLoad() {
        if (this.get_InitFn()) {
            if (typeof (window[this.get_InitFn()]) !== 'undefined') {
                window[this.get_InitFn()](this);
            }
        }

        this._onLoad(null, {});
        this.asyncLoad();
    }
    asyncLoad() {

    }
    _launchAjaxLoad(sender, args) {
        this.raiseOnEventLoad(sender, args);
        this.set_AjaxLoad(false);
    }
    launchAjaxLoad() {

    }
    ready(handler) {
        if (this.isReady) {
            //GBAU - 14/09/2012 - DYSF51947 : On passe des arguments car les handlers en attendent !
            handler(this, {});
        } else {
            this.get_events().addHandler("ready", handler);
        }
    }
    /**
     * Permet d'indiquer que le composant est ready
     */
    _ready() {
        this._onReady(this, {});
        this.isReady = true;
    }
    _onReady(sender, args) {
        var handler = this.get_events().getHandler("ready");
        if (handler) {
            handler(sender, args);
            this.get_events().removeHandler("ready", handler);
        }
        this.onReady();
        return;
    }
    onReady() {
    }
    raiseOnEventLoad(sender, args) {
        this.raiseOnEvent("Load", {});
        //this.raiseOnEvent("Load", { data: this.get_Dto(), callback: me.onLoad, callbackParams: [sender, args] });
    }
    _getDtoForServer(eventId) {
        return this.getDtoForServer(eventId);
    }
    getDtoForServer(eventId) {
        return this.get_Dto();
    }
    _configureHttpHandlerOverridable() {

    }
    _declareEventsOverridable() {

    }
    _getResizableOptions() {
        return function (me) {
            var options = me.getResizableOptions({
                start: function (event, ui) { me._onResizeStart(event, ui); },
                resize: function (event, ui) { me._onResizePerform(event, ui); },
                stop: function (event, ui) { me._onResizeStop(event, ui); }
            });
            // YLAR 22/03/2012 : Lorsque l'on redimensionne un composant on redimensionne aussi son Conteneur
            if (options.alsoResize) {
                options.alsoResize += ',  #' + me.getId() + '> .Wrapper';
            }
            return options;
        }(this);
    }
    getResizableOptions(options) {
        return options;
    }
    _getDraggableOptions() {
        return function (me) {
            return me.getDraggableOptions({ stop: function (event, ui) { me._onDragStop(event, ui); } })
        }(this);
    }
    getDraggableOptions(options) {
        return options;
    }
    _onResizeStart(event, ui) {
        this.onResizeStart(event, ui);
    }
    onResizeStart(event, ui) {
        //Virtual
    }
    _onResizePerform(event, ui) {
        this.onResizePerform(event, ui);
    }
    onResizePerform(event, ui) {
        //Virtual
    }
    _onResizeStop(event, ui) {
        this.isResizedByClient = true;
        this.onResizeStop(event, ui);
    }
    add_onResized(handler) {
        this.get_events().addHandler("onResized", handler);
    }
    remove_onResized(handler) {
        this.get_events().removeHandler("onResized", handler);
    }
    onResizeStop(event, ui) {
        var handler = this.get_events().getHandler("onResized");
        if (handler) handler(event, ui);
        return;
    }
    _onDragStop(event, ui) {
        this.onDragStop(event, ui);
    }
    onDragStop(event, ui) {

    }
    refresh(showLoading: boolean) {
        this.refreshOverridable();
    }
    refreshOverridable() {
        this.raiseOnEventLoad(this, {});
    }
    add_onEvent(handler) {
        this.get_events().addHandler("onEvent", handler);
    }
    remove_onEvent(handler) {
        this.get_events().removeHandler("onEvent", handler);
    }
    _onEvent(sender, args) {
        var handler = this.get_events().getHandler("onEvent");
        if (handler) {
            // Appelle le handler de l'evenement
            handler(sender, args);
        } else {
            // Appelle la callback de l'evenement
            this._asyncCallBack({}, args.callback, args.callbackParams);
        }
        return;
    }
    add_ViewUpdating(handler) {
        this.addEventHandler("ViewUpdating", handler);
    }
    remove_ViewUpdating(handler) {
        this.removeEventHandler("ViewUpdating", handler);
    }
    _ViewUpdating(sender, args) {
        if (this.enableViewUpdatingEvent) {
            this._onViewUpdating(sender, args);
            this.raiseEvent("ViewUpdating", args);
        }
    }
    _onViewUpdating(sender, args) {
        this.onViewUpdating(sender, args);
    }
    onViewUpdating(sender, args) {
        // Virtual
    }
    _RegisterClientEventsHandlers() {
        /// <summary>
        /// Enregistre tous les handlers definit cote serveur sur le composant. 
        /// </summary>
        var cevh = this.get_ClientEventsHandlers();
        if (cevh) {
            for (var eventName in cevh) {
                var handlerNames = cevh[eventName];
                handlerNames.forEach(function (me) {
                    return function (handlerName) {
                        let handler;
                        //GBAU - 10/09/2018 : Ajout de la possibilité de passer une fonction anonyme
                        if (handlerName.indexOf("function(") === 0) {
                            eval("handler=" + handlerName);
                        } else {
                            eval("handler=window." + handlerName);
                        }
                        if (typeof handler == "function") {
                            me.addEventHandler(eventName, handler);
                        }
                    }
                }(this));
            }
        }
    }
    raiseOnEvent(eventName, args) {
        this.prepareArgsCallBack(args);
        this._beforeRaiseOnEventOverridable(eventName, args);
        this._onEvent(this, { eventName: eventName, data: args.data, callback: args.callback, callbackParams: args.callbackParams, errorCallback: args.error, errorCallbackParams: args.errorParams });
    }
    /**
     * Méthode surchargeable permettant d'effectuer un traitement sur les args d'une évènement avant de le lever
     * @param {String} eventName Le nom de l'évènement
     * @param {Object} args Les arguments de l'évènement
     */
    _beforeRaiseOnEventOverridable(eventName, args) {
        /// <history>
        ///		 <entry mat="GBAU" date="01/12/2016" task="129968">Création</entry>
        /// <history>

    }
    prepareArgsCallBack(args) {
        var callback;
        var errorCallback;
        var initialCallback;
        var initialCallbackParams;
        if (args.data == undefined) {
            args.data = null;
        }

        if (args.callback == undefined) {
            args.callback = null;
        }

        if (args.callbackParams == undefined) {
            args.callbackParams = null;
        }

        if (args.showLoading == undefined) {
            args.showLoading = true;
        }

        //29/06/2016 - DEV123704 : Ajout d'un callback en cas d'erreur
        if (typeof (args.errorCallback) === 'undefined') {
            args.errorCallback = null;
        }

        if (typeof (args.errorCallbackParams) === 'undefined') {
            args.errorCallbackParams = null;
        }

        initialCallback = args.callback;
        initialCallbackParams = args.callbackParams;
        callback = function (me) {
            return function () {
                if (typeof (initialCallback) !== "undefined") {
                    //GBAU - 28/02/2017 - DEV133769 - La fonction callback ci-dessus prend la place de la fonction callback définie lors de la levé de l'évènement.
                    //et c'est cette fonction callback qui appelle celle définit ors de la levé de l'évènement. Le problème est qu'il n'est pas
                    //possible de savoir au niveau noyau les paramètres que prenait la fonction que l'on à substituée. Cependant,
                    //le code qui va déclencher la callback va passer les paramètres quand même à celle-ci ce qui nous permet de les récupérer et de les repasser
                    //à la sous-callback
                    initialCallbackParams = initialCallbackParams || [];
                    jQuery.each(arguments, function (i, arg) {
                        initialCallbackParams.push(arg);
                    })
                    me.callCallback(initialCallback, initialCallbackParams);
                }
            }
        }(this);
        args.callback = callback;
        args.callbackParams = null;

        return true;
    }
    //#endregion EventHandler

    //#region Server Sides Get/Set
    get_Dto() {
        return this.dto;
    }
    set_Dto(value) {
        if (!(value instanceof IsiDtoComponentV4)) {
            value = this._createInstanceOfDtoOverridable(value);
        }
        this.dto = value;
    }
    getDto() {
        return this.dto;
    }
    get_ServerId() {
        return this.serverId;
    }
    set_ServerId(value) {
        this.serverId = value;
        return;
    }
    get_ChildId() {
        return this.childId;
    }
    set_ChildId(value) {
        this.childId = value;
        return;
    }
    get_BiologicParent() {
        return this.biologicParent;
    }
    set_BiologicParent(value) {
        this.biologicParent = value;
        return;
    }
    get_Group() {
        return this.group;
    }
    set_Group(value) {
        this.group = value;
    }
    get_EnableLoadingPanel() {
        return this.enableLoadingPanel;
    }
    set_EnableLoadingPanel(value) {
        this.enableLoadingPanel = value;
    }
    get_ShowLoadingPanelOnLoad() {
        return this.showLoadingPanelOnLoad;
    }
    set_ShowLoadingPanelOnLoad(value) {
        this.showLoadingPanelOnLoad = value;
    }
    get_UseParentLoadingPanel() {
        return this.useParentLoadingPanel;
    }
    set_UseParentLoadingPanel(value) {
        this.useParentLoadingPanel = value;
    }
    get_InstanceType(value) {
        return this._instanceType;
    }
    set_InstanceType(value) {
        this._instanceType = value;
    }
    get_ClientEventsHandlers() {
        return this.ClientEventsHandlers;
    }
    set_ClientEventsHandlers(value) {
        this.ClientEventsHandlers = value;
    }
    get_ErrorOnLoad() {
        return this.errorOnLoad;
    }
    set_ErrorOnLoad(value) {
        this.errorOnLoad = value;
    }
    get_AjaxLoad() {
        return this.ajaxLoad;
    }
    set_AjaxLoad(value) {
        this.ajaxLoad = value;
    }
    get_UseController() {
        return this.useController;
    }
    set_UseController(value) {
        this.useController = value;
    }
    get_EnableClientResize() {
        return this.activateClientResize;
    }
    set_EnableClientResize(value) {
        this.activateClientResize = value;
    }
    get_EnableClientDrag() {
        return this.activateClientDrag;
    }
    set_EnableClientDrag(value) {
        this.activateClientDrag = value;
    }
    getIsResizedByClient() {
        return this.isResizedByClient;
    }
    get_AttachedComponents() {
        return this.attachedComponents;
    }
    set_AttachedComponents(value) {
        this.attachedComponents = value;
    }
    //[GBAU] 18/01/2012 Created - DYSF46334
    get_EnableUserAction() {
        return this.enableUserAction;
    }
    set_EnableUserAction(value) {
        this.enableUserAction = value;
    }
    //[GBAU] 18/01/2012 Created - DYSF46334
    get_EnableToolbar() {
        return this.enableToolbar;
    }
    set_EnableToolbar(value) {
        this.enableToolbar = value;
    }
    get_ReadOnly() {
        return this.readOnly;
    }
    set_ReadOnly(value) {
        this.readOnly = value;
        if (value == true) {
            this.addClass("rdo");
        }
    }
    get_Label() {
        /// <summary>
        /// Getter de la propriété label créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        return this.label;
    }
    set_Label(value) {
        /// <summary>
        /// Setter de la propriété label créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        this.label = value;
    }
    get_LabelPosition() {
        /// <summary>
        /// Getter de la propriété labelPosition créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        return this.labelPosition;
    }
    set_LabelPosition(value) {
        /// <summary>
        /// Setter de la propriété labelPosition créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        this.labelPosition = value;
    }
    get_LabelCreationMode() {
        /// <summary>
        /// Getter de la propriété labelCreationMode créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        return this.labelCreationMode;
    }
    set_LabelCreationMode(value) {
        /// <summary>
        /// Setter de la propriété labelCreationMode créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        this.labelCreationMode = value;
    }
    get_LabelCssClass() {
        /// <summary>
        /// Getter de la propriété labelCssClass créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        return this.labelCssClass;
    }
    set_LabelCssClass(value) {
        /// <summary>
        /// Setter de la propriété labelCssClass créé dans la fonction IsiGetJSProperties.
        /// </summary>
        /// <history>
        ///		 <entry mat="ybru" date="02/07/2015" task="1017501">Création</entry>
        /// <history>

        this.labelCssClass = value;
    }
    get_HttpHandlerUrl() {
        return this.httpHandlerUrl;
    }
    set_HttpHandlerUrl(url) {
        this.httpHandlerUrl = url;
    }
    //#endregion Server Side Get/Set

    getId(cssEscape?) {
        var id = this.get_id();
        if (!id) {
            id = this.getJQueryElement().attr("id");
        }
        if (cssEscape) {
            id = CSS.escape(id);
        }
        return id;
    }
    get_EnableViewUpdatingEvent() {
        return this.enableViewUpdatingEvent;
    }
    set_EnableViewUpdatingEvent(value) {
        this.enableViewUpdatingEvent = value;
    }
    get_NbC() {
        return this.nbChild;
    }
    set_NbC(value) {
        this.nbChild = value;
    }
    get_ML() {
        return this.manualLoad;
    }
    set_ML(value) {
        this.manualLoad = value;
    }
    get_EPD() {
        return this.enablePostData;
    }
    set_EPD(value) {
        this.enablePostData = value;
    }
    get_ViewMode() {
        //return this.viewMode;
        return this._viewMode;
    }
    set_ViewMode(value) {
        this._viewMode = value
    }
    _isMotion() {
        return this._motion;
    }
    setMotion(value) {
        this._motion = value;
    }
    getMotionOptions() {
        if (!this._motionOptions) {
            this._motionOptions = this._initializeMotionOptionsOverridable();
        }
        return this._motionOptions;
    }
    setMotionOptions(value) {
        this._motionOptions = value;
        this._setMotionOptionsOverridable(value);
        return this._motionOptions;
    }
    _setMotionOptionsOverridable(value) {

    }
    _initializeMotionOptionsOverridable() {
        return {};
    }
    registerChild(child) {
        var childId;
        childId = child.get_ChildId().toLowerCase();

        //GBAU - 24/08/2018 - Dans certain cas, on tombe sur une fonction comme par exemple si le childId est add
        if (typeof (this.childsId[childId]) !== "undefined" && typeof (this.childsId[childId]) !== 'function') return true;

        this.nbChildFound++;

        this.childsId[childId] = this.childs.length;
        this.childs[this.childs.length] = child;

        if (childId == "wrapper") {
            this.wrapper = child;
            this.wrapper.childsFoundHandlers = this.childsFoundHandlers;
            this.childsFoundHandlers = [];
            //GBAU - 03/11/2016 - RWD DEV127803
            this.wrapper.childsInitializedHandlers = this.childsInitializedHandlers;
            this.childsInitializedHandlers = [];
            this.wrapper.childsReadyHandlers = this.childsReadyHandlers;
            this.childsReadyHandlers = [];
        }
        if (this.extended == true && childId == "ExtendedControl") {
            this.control = child;
        }


        //GBAU - 18/01/2012 - DYSF46334
        //child.set_EnableUserAction(this.get_EnableUserAction());
        //child.set_EnableToolbar(this.get_EnableToolbar());

        this.afterRegisterChild(child);
        //GBAU - 24/08/2018 - Dans certain cas, on tombe sur une fonction comme par exemple si le childId est add fonc on test s'il il s'agit bien d'un array
        if (this.wrapper.childsFoundHandlers[childId] != undefined && Array.isArray(this.wrapper.childsFoundHandlers[childId])) {
            for (var i = 0; i < this.wrapper.childsFoundHandlers[childId].length; i++) {
                var func = this.wrapper.childsFoundHandlers[childId][i];
                if (!func.called) {
                    func(child);
                    func.called = true;
                }

            }
        }
        //GBAU - 03/11/2016 - RWD DEV127803
        //GBAU - 24/08/2018 - Dans certain cas, on tombe sur une fonction comme par exemple si le childId est add fonc on test s'il il s'agit bien d'un array
        if (this.wrapper.childsInitializedHandlers[childId] != undefined && Array.isArray(this.wrapper.childsInitializedHandlers[childId])) {
            for (var i = 0; i < this.wrapper.childsInitializedHandlers[childId].length; i++) {
                var func = this.wrapper.childsInitializedHandlers[childId][i];
                child.add_onInitialized(func);
            }
        }
        //GBAU - 24/08/2018 - Dans certain cas, on tombe sur une fonction comme par exemple si le childId est add fonc on test s'il il s'agit bien d'un array
        if (this.wrapper.childsReadyHandlers[childId] != undefined && Array.isArray(this.wrapper.childsReadyHandlers[childId])) {
            for (var i = 0; i < this.wrapper.childsReadyHandlers[childId].length; i++) {
                var func = this.wrapper.childsReadyHandlers[childId][i];
                child.ready(func);
            }
        }
        child.add_ViewUpdating(function (me) {
            return function (sender, args) {
                me._ViewUpdating(sender, args);
            };
        }(this));

        if (this.nbChild > 0 && this.nbChild == this.nbChildFound) {
            this.allChildFound();
        }
    }
    allChildFound() {
        this.allChildFoundOverridable();
    }
    allChildFoundOverridable() {

    }
    afterRegisterChild(child) {
    }
    childExist(id) {
        return (this.childsId[id.toLowerCase()] != undefined);
    }
    getChildById(id) {
        var child;
        var childId;
        if (id) {
            //JOBO 09/02/2015
            //La page d'accueil n'est plus configurable lorsque aucun composant n'est actif
            childId = id.toLowerCase();
            child = this.childs[this.childsId[childId]]
            if (this.wrapper != this && this.wrapper && !child) {
                child = this.wrapper.getChildById(childId);
            }
            if (!child) {
                child = window.Sys.Application.findComponent(childId);
                if (child) {
                    this.registerChild(child);
                }
            }
        }
        return child;
    }
    whenChildFound<T extends IsiComponentV4>(childId, handler: (child: T) => void) {
        var child;
        childId = childId.toLowerCase();
        child = this.getChildById(childId);
        if (child) {
            handler(child);
        } else {
            if (this.wrapper.childsFoundHandlers[childId] == undefined) {
                this.wrapper.childsFoundHandlers[childId] = new Array();
            }
            this.wrapper.childsFoundHandlers[childId].push(handler);
        }
    }
    remove_AllWhenChildFound(childId) {
        this.wrapper.childsFoundHandlers[childId] = undefined;
    }
    whenChildInitialized<T extends IsiComponentV4>(childId, handler: (child: T) => void) {
        var child;
        childId = childId.toLowerCase();
        child = this.getChildById(childId);
        if (child) {
            handler(child);
        } else {
            if (this.wrapper.childsInitializedHandlers[childId] == undefined) {
                this.wrapper.childsInitializedHandlers[childId] = new Array();
            }
            this.wrapper.childsInitializedHandlers[childId].push(handler);
        }
    }
    whenChildReady<T extends IsiComponentV4>(childId, handler: (child: T) => void) {
        var child;
        childId = childId.toLowerCase();
        child = this.getChildById(childId);
        if (child) {
            child.ready(handler);
        } else {
            if (this.wrapper.childsReadyHandlers[childId] == undefined) {
                this.wrapper.childsReadyHandlers[childId] = new Array();
            }
            this.wrapper.childsReadyHandlers[childId].push(handler);
        }
    }
    getAttributeValue(name) {
        var attribute = this.get_element().attributes[name]
        if (attribute) {
            return attribute.value;
        } else {
            return null;
        }
    }
    getBoolAttributeValue(name) {
        var value = this.getAttributeValue(name)
        return Boolean(value);
    }
    get_Controller() {
        return this.controller;
    }
    set_Controller(value) {
        this.controller = value;
    }
    get_Extended() {
        return this.extended;
    }
    set_Extended(value) {
        this.extended = value;
    }
    get_InitFn() {
        return this._initFn;
    }
    set_InitFn(value) {
        this._initFn = value;
    }
    // MBRO - 15/02/2018 - DEV138958 - Gestion des booléens indiquant si le composant affiche un header et|ou un footer
    get_ShowHeader() {
        return this.showHeader;
    }
    set_ShowHeader(value) {
        this.showHeader = value;
    }
    get_ShowFooter() {
        return this.showFooter;
    }
    set_ShowFooter(value) {
        this.showFooter = value;
    }
    addEventHandler(key, handler) {
        this.get_events().addHandler(key, handler);
    }
    removeEventHandler(key, handler) {
        this.get_events().removeHandler(key, handler);
    }
    raiseEvent(key, args) {
        if (args == undefined) {
            args = {};
        }
        if (args.getStopPropagation == undefined) {
            args.getStopPropagation = function () {
                return this.stopPropagation;
            };

            args.setStopPropagation = function (value) {
                this.stopPropagation = value;
            };

            args.stopPropagation = false;
        }

        var handler = this.get_events().getHandler(key);
        if (handler) handler(this, args);

        return;
    }
    checkViewUpdatingForced(eventid) {
        ///<summary>verifie si pour l'evenement passe en parametre il faut quand meme lever la modification<summary>
        if (this.viewUpdatingForcedForEvents[eventid]) {
            return true;
        } else {
            if (this.viewUpdatingForcedForEvents != null) {
                return false;
            } else {
                return true;
            }
        }
    }
    registerViewUpdatingEvent(eventid) {
        ///<summary>indique que l'event gere la modification<summary>
        if (this.viewUpdatingForcedForEvents == null)
            this.viewUpdatingForcedForEvents = [];
        this.viewUpdatingForcedForEvents[eventid] = eventid;
    }
    raiseViewUpdatingEvent(eventId) {
        var event;
        if (eventId) {
            event = { id: eventId };
        }
        if (this.checkRaiseViewUpdatingEvent(event)) {
            this._ViewUpdating(this, {});
            this.raiseOnEvent("ViewUpdating", {});
        }
    }
    checkRaiseViewUpdatingEvent(event) {
        ///<summary>verifie si pour l'evenement passe en parametre il faut quand meme lever la modification<summary>
        if (this.enableViewUpdatingEvent) {
            if (event) {
                return this.checkViewUpdatingForced(event.id);
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
    raiseViewUpdatedEvent() {
        this.raiseOnEvent("ViewUpdated", {});
    }
    doPostBack(eventName, data, json) {
        var encodedData
        (json == undefined) ? json = true : json;

        var object;
        //GBAU - 14/09/2012 - DYSF51947 : On passe {} au lieu de null dans le dto
        object = new IsiComponentClientEventArgs("PostBack", this.getId(), eventName, data, {});
        encodedData = object;
        if (json == true) {
            encodedData = jQuery.toJSON(object);
        }
        __doPostBack(this.getId(), encodedData);
    }
    doPostBackAsync(eventName, data, json) {
        var encodedData
        (json == undefined) ? json = true : json;

        var args = { callback: Function() };
        if (data.callback) {
            args.callback = data.callback;
            data.callback = null;
        }

        var object;
        object = new IsiComponentClientEventArgs("PostBack", this.getId(), eventName, data, null)
        encodedData = object;
        if (json == true) {
            encodedData = jQuery.toJSON(object);
        }


        this.prepareArgsCallBack(args);
        doPostBackAsync(this.getId(), encodedData, args.callback);
    }
    getJQueryElement() {
        //ABON retournait une collection vide si disposed avant maintenant vu avec GBAU retourne null
        if (this.jQueryElement == undefined && !this.disposedValue) {
            this.jQueryElement = jQuery(this.get_element());
        }
        return this.jQueryElement;
    }
    getJQueryChildrenElement(selector, directChildren?) {
        //GBAU - 27/06/2016 - Désormais la méthode prend un second paramètre indiquant si la recherche s'effectue uniquement sur les fils directs
        if (this.jQueryElement == undefined) {
            this.jQueryElement = jQuery(this.get_element());
        }
        if (directChildren) {
            return this.jQueryElement.children(selector);
        } else {
            return this.jQueryElement.find(selector);
        }
    }
    getJQueryParentElement() {
        if (this.jQueryParentElement == undefined) {
            this.jQueryParentElement = jQuery(this.get_element()).parent();
        }
        return this.jQueryParentElement;
    }
    _getUseResponsiveWaitBarOverridable() {
        return false;
    }
    _getUseFixedWaitBarOverridable() {
        return false;
    }
    _createShowLoadingTimeout(minDuration) {
        typeof (minDuration) == "undefined" && (minDuration = this._settings.showLoadingOnRefreshWebpartMinDuration);

        if (this._showLoadingTimeout == null && minDuration > 0) {
            this._canHideLoading = false;
            this._showLoadingTimeout = setTimeout(function (me) {
                return function () {
                    me._showLoadingTimeout = null;

                    if (me._canHideLoading) {
                        me.showLoading(false);
                    }

                };
            }(this), minDuration)
        }

        //this._showLoadingTimeout
    }
    showLoading(value, progress?, minDuration?) {
        if ((this.get_UseParentLoadingPanel() || (this.get_parent() && this.get_parent().wrapper == this)) && this.get_parent()) {
            this.get_parent().showLoading(value, progress, minDuration);
        } else {
            if (this.enableLoadingPanel) {
                if (value) {
                    var useProgressBar = this.useProgressBar && typeof (progress) !== 'undefined';
                    if (!this.loadingElement) {
                        this.loadingElement = this.getJQueryChildrenElement(">.IsiWaitBar");
                        if (!this.loadingElement) {
                            this.loadingElement = jQuery("#" + this.getId(true) + "_IsiLoadingPanel");
                        }

                    }
                    this.loadingElement.addClass("IsiWaitBarActive");
                    this.getJQueryElement().removeClass("loaded").addClass("loading");
                    if (useProgressBar) {
                        this.loadingElement.addClass("WithoutMsg");
                    }

                    if (this._getUseResponsiveWaitBarOverridable()) {
                        //GBAU - 02/03/2018 - DEV141524 - Intégration FW V4
                        this.loadingElement.addClass("responsive");
                    } else {
                        var jRefElement = this.getJQueryElement();

                        //Voile décalé en IE7 en mode config du portail
                        this.loadingElement.offset(jRefElement.offset());
                        //this.loadingElement.position({
                        //    my: "top left",
                        //    at: "top left",
                        //    of: jRefElement
                        //})

                        var width;
                        if (jQuery('body').hasClass("zoomOn")) {
                            width = jRefElement[0].clientWidth;
                        } else {
                            width = jRefElement.outerWidth(true);
                        }

                        if (width > 0) {
                            this.loadingElement.width(width);
                        }

                        var height = jRefElement.height();
                        if (height > 0) {
                            this.loadingElement.height(height);
                        }
                    }

                    if (this._getUseFixedWaitBarOverridable()) {
                        this.loadingElement.addClass("IsiWaitBarFixed");
                    }


                    if (useProgressBar) {
                        this.updateProgress(progress);
                    }

                    //GBAU - 06/02/2017 - DYSF78515 : On prévient que le composant est en chargement
                    this._onLoading();

                    this._createShowLoadingTimeout(minDuration);
                } else {
                    if (this._showLoadingTimeout) {
                        this._canHideLoading = true;
                    } else {
                        if (this.loadingElement) {
                            this.loadingElement.removeClass("IsiWaitBarActive");
                            this.getJQueryElement().removeClass("loading").addClass("loaded");
                        }
                        //GBAU - 06/02/2017 - DYSF78515 : On prévient que le composant est chargé
                        this._loaded();
                    }
                }
            }
        }
    }
    updateProgress(progressObject, callback?) {
        if (!this.progressBar && this.useProgressBar) {
            this.progressBar = window.Ext.create('Ext.ProgressBar', {
                renderTo: this.get_id(),
                width: 300,
                /*animate: true,*/
                floating: true
            });
        }
        if (this.progressBar) {
            if (progressObject) {
                this.progressBar.updateProgress(progressObject.value, progressObject.text);
                this.progressBar.show();
                if (callback) {
                    setTimeout(callback, 100);
                }
            } else {
                this.progressBar.hide();
            }
        } else {
            if (callback) {
                callback();
            }
        }
    }
    _asyncCallBack(eventArgs, callback, callbackParams) {
        if (eventArgs != undefined && eventArgs.error == undefined) {
            this.asyncCallBack(eventArgs, callback, callbackParams);
            if (callback) {
                if (callbackParams) {
                    this.callCallback(callback, callbackParams);
                } else {
                    callback(eventArgs);
                }
            }
            // On parcours les notifications informations pour afficher un feedback
            if (eventArgs != undefined && eventArgs.informations != undefined) {
                var info = "";
                for (var i = 0; i < eventArgs.informations.length; i++) {
                    info += eventArgs.informations[i] + "<br />";
                }
                uiCore.showMessage(info);
            }
        } else {
            this.showLoading(false);

            //29/06/2016 - DEV123704 : Ajout d'un callback en cas d'erreur
            if (callback) {
                if (callbackParams) {
                    this.callCallback(callback, callbackParams);
                } else {
                    callback(eventArgs);
                }
            }

            if (eventArgs != undefined && eventArgs.error != undefined) {
                var message = false;;
                if (typeof (eventArgs.error.ErrorMessage) !== 'undefined') {
                    message = eventArgs.error.ErrorMessage
                } else if(eventArgs.error.errorMessage){
                    message = eventArgs.error.errorMessage
                } else if (typeof (eventArgs.error.message) !== 'undefined') { //Compatibilité ascendante
                    message = eventArgs.error.message;
                }
                if (message) {
                    this.showError(message);
                }
            }
        }


        //this._onLoad();
    }
    asyncCallBack(eventArgs, callback, callbackParams) {
    }
    callCallback(callback, callbackParams) {
        if (callback) {
            if (!callbackParams) {
                callbackParams = new Array();
            }
            callback.apply(this, callbackParams);
        }
    }
    show() {
        this.getJQueryElement().show();
        this._afterShowOverridable();
    }
    _afterShowOverridable() {
        ///<summary>Permet d'afficher certaines chose lors de l'affichage du composant</summary>
    }
    hide() {
        this._beforeHideOverridable();
        this._hideOverridable();
        this._onHidden();
    }
    _hideOverridable() {
        this.getJQueryElement().hide();
    }
    _beforeHideOverridable() {
        ///<summary>Permet de masquer certaines chose lors du masquage du composant</summary>
    }
    add_onHidden(handler) {
        /// <summary>
        ///   This event fires with a frequency determined by the interval.
        /// </summary>
        this.get_events().addHandler("onHidden", handler);
    }
    remove_onHidden(handler) {
        this.get_events().removeHandler("onHidden", handler);
    }
    _onHidden(sender?, args?) {
        var handler = this.get_events().getHandler("onHidden");
        if (handler) handler(sender, args);
    }
    enableClientResize() {
        if (this.get_EnableClientResize()) {
            this.getJQueryElement().resizable("enable");
        }
    }
    disableClientResize() {
        if (this.get_EnableClientResize()) {
            this.getJQueryElement().resizable("disable");
        }
    }
    showError(message) {
        this.showErrorOverridable(message, true);
    }
    showErrorOverridable(message, isError) {
        uiCore.showFeedback(message, isError);
    }
    getAjaxLoaded() {
        return this.ajaxLoaded;
    }
    setAjaxLoaded(value) {
        this.ajaxLoaded = value;
    }
    ensureFullScreen() {

    }
    stopPropagation(event) {
        //GBAU - 21/09/2012 - DYSF52264
        stopPropagation(event);
    }
    addClass(value) {
        this.getJQueryElement().addClass(value);
        this.afterAddClass(value);
    }
    removeClass(value) {
        this.getJQueryElement().removeClass(value);
    }
    afterAddClass(value) {
        return true;
    }
    _getFullScreenOptions() {
        /// <summary>
        /// Cette fonction permet de retourner les options utilisé lors du passage en mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// CLEM - 11/02/2016 - DEV117618 - Monter de version Fancybox.  
        /// <history>
        return function (me) {

            var width;
            var height;
            var autoWidth;
            var autoHeight;

            // MBRO - 21/07/2017 - DEV 137831 - Fullscreen RWD
            // Détermine les dimensions PAR DEFAUT de la fenêtre d'agrandissement selon le mode|device
            if (uiCore.isRWD()) {
                // Mode RWD
                switch (uiCore.getClient().RWDMode) {
                    default:
                        height = "80%";
                        width = "80%";
                    case IsiRWDMode.Phone:
                        height = "95%";
                        width = "95%";
                        break;
                    case IsiRWDMode.Tablet:
                        switch (uiCore.getClient().RWDLength) {
                            case IsiRWDLength.Small:
                                height = "90%";
                                width = "90%";
                                break;
                        }
                        break;
                }
            } else {
                // Mode VINTAGE
                width = 500;
                height = null;
            }

            var options = {};

            options = jQuery.extend(options, me._getFullScreenOptionsOverridable({
                content: jQuery("#" + me.getId()),
                infobar: false,
                buttons: false,
                closeBtn: false,
                smallBtn: false,
                margin: [0, 0],
                type: 'inline',
                scrolling: 'no',
                afterLoad: function (sender) {
                    me._afterFullScreen(sender);
                },
                beforeClose: function () {

                },
                afterClose: function (options) {
                    return function (sender) {
                        me._beforeSmallScreen(options);
                        me.show();
                        me._afterSmallScreen(options);
                    }
                }(options),
                initialDisplay: me.getJQueryElement().css("display") //Options Isilog, pas Fancybox
            }));

            //if (options.width.indexOf("%") !== -1) {
            //    var iWindowWidth = jQuery(window).width();
            //    options.width = Math.floor(iWindowWidth * (parseInt(options.width) / 100)) + "px";
            //    options.autoWidth = false;
            //}

            //if (options.height.indexOf("%") !== -1) {
            //    var iWindowHeight = jQuery(window).height();
            //    options.height = Math.floor(iWindowHeight * (parseInt(options.height) / 100)) + "px";
            //    options.autoHeight = false;
            //}

            return options;
        }(this);
    }
    _getFullScreenOptionsOverridable(options) {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="_getFullScreenOptions" />
        /// ATTENTION : les options "height" et "width" doivent prendre en compte les modes Vintage/RWD
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        return options;
    }
    toggleViewMode() {
        /// <summary>
        /// Cette fonction permet de switcher entre le mode normal et le mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        if (this.get_ViewMode() == window.IsiFW.IsiComponent.Enums.ViewMode.SmallScreen) {
            this.fullScreen();
        } else {
            this.smallScreen();
        }
    }
    smallScreen() {
        /// <summary>
        /// Cette fonction permet de quitter le mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        jQuery.fancybox.close();
    }
    fullScreen(callback?) {
        /// <summary>
        /// Cette fonction permet d'afficher le composant en mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>

        var options;
        options = this._getFullScreenOptions();

        this._beforeFullScreen(options);

        if (typeof (callback) !== "undefined") {
            options.afterLoad = function (initialCallback, callback) {
                return function (sender) {
                    initialCallback(sender);
                    callback(sender);
                }
            }(options.afterLoad, callback)
        }

        // JSOU 09/11/2017 Ajout du paramètre touch:false qui bloque le clic en mode fullscreen sur mobile
        jQuery.fancybox.open({ src: options.content, type: options.type, touch: false }, options);
    }
    _beforeSmallScreen(options) {
        /// <summary>
        /// Cette fonction est déclencher avant l'affichage du composant en mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>

        //On remet le composant dans sa taille initiale
        var width;
        var height;

        if (options.smallScreenAutoWidth) {
            width = "auto";
        } else {
            width = this._initialSmallScreenWidth;
        }

        if (options.smallScreenAutoHeight) {
            height = "auto";
        } else {
            height = this._initialSmallScreenHeight;
        }


        this.updateSize(width, height);

        if (options.initialDisplay) {
            this.getJQueryElement().css("display", options.initialDisplay);
        }

        //On réactive le redimensionnement client qui est désactivé lors du passage en plein écran
        this.enableClientResize();

        this.getJQueryElement().removeClass("fullscreen");

        // Montée de version Fancybox 3.3.5 - Désormais la classe "fancybox-content" est ajoutée lors de l'ouverture. On la retire donc lors du retour en smallscreen
        this.getJQueryElement().removeClass("fancybox-content");

        // MBRO - 25/09/2018 - Dysf 84180 - Deverrouillage du body de la page parente
        this._unlockBodyScroll();

        //GBAU - 26/12/2012 - On passe les nouvelles valeurs de largeur et hauteur
        return this._beforeSmallScreenOverridable(this._initialSmallScreenWidth, this._initialSmallScreenHeight);
    }
    _beforeSmallScreenOverridable(width, height) {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="_beforeSmallScreen" />
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        return true;
    }
    _afterSmallScreen(sender) {
        /// <summary>
        /// Cette fonction est appelée après que le composant est quitté le mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>

        this.set_ViewMode(window.IsiFW.IsiComponent.Enums.ViewMode.SmallScreen);
        return this._afterSmallScreenOverridable(sender);
    }
    _afterSmallScreenOverridable(sender) {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="_afterSmallScreen" />
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        return true;
    }
    _beforeFullScreen(options) {
        /// <summary>
        /// Cette fonction est appelée avant que le composant soit affiché en mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>

        // CLEM - On traite la taille initiale avant de la flingué
        //Le composant passe en plein écran, on sauvegarde donc ses dimensions initiales afin de pouvoir le rétablir
        //lorsque l'on reviendra en mode normal
        this._initialSmallScreenWidth = this.getJQueryElement().width();
        this._initialSmallScreenHeight = this.getJQueryElement().height();

        if (this.getJQueryElement().css('height')) {
            this.getJQueryElement().css({ 'height': '', 'width': '' });
        }
        var width;
        var height;

        if (options.width) {
            width = options.width;
        } else {
            var iWindowWidth = jQuery(window).width();
            width = Math.floor(iWindowWidth * .95) + 1;
        }

        if (options.height) {
            height = options.height;
        } else {
            var iWindowHeight = jQuery(window).height();
            height = Math.floor(iWindowHeight * .95) + 1;
        }

        //On redimensionne le composant pour l'affichage en plein écran
        this.updateSize(width, height);

        this.getJQueryElement().addClass("fullscreen");

        this.disableClientResize();

        // MBRO - 25/09/2018 - Dysf 84180 - Verrouillage du body de la page parente (empêche scroll arrière-plan)
        this._lockBodyScroll();

        this._beforeFullScreenOverridable(width, height);
    }
    _beforeFullScreenOverridable(width, height) {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="_beforeFullScreen" />
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        return true;
    }
    _afterFullScreen(sender) {
        /// <summary>
        /// Cette fonction est appelée après que le composant soit affiché en mode plein écran
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        this.set_ViewMode(window.IsiFW.IsiComponent.Enums.ViewMode.FullScreen);
        return this._afterFullScreenOverridable(sender);
    }
    _afterFullScreenOverridable(sender) {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="_afterFullScreen" />
        /// </summary>
        /// <history>
        /// GBAU - 29/11/2012 - Création - DEV58867
        /// <history>
        return true;
    }
    /**
     * Cette fonction permet de modifier la taille du composant
     * @param {Integer|Float|Boolean} width La nouvelle largeur
     * @param {Integer|Float|Boolean} height La nouvelle hauteur
     * @param {Integer|Float} widthDiff La différence de largeur (positive ou négative)
     * @param {Integer|Float} heightDiff La différence de hauteur (positive ou négative)
     * @returns
     */
    updateSize(width, height, widthDiff?, heightDiff?) {
        /// <history>
        /// <entry mat="[GBAU]" date="29/11/2012" task="58867">Création</entry>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Modification</entry>
        /// <history>

        return this._updateSizeOverridable(width, height, widthDiff, heightDiff);
    }
    /**
     * Cette fonction surchargeable est appelée par la fonction updateSize
     * @param {Integer|Float|Boolean} width La nouvelle largeur
     * @param {Integer|Float|Boolean} height La nouvelle hauteur
     * @param {Integer|Float} widthDiff La différence de largeur (positive ou négative)
     * @param {Integer|Float} heightDiff La différence de hauteur (positive ou négative)
     * @returns
     */
    _updateSizeOverridable(width, height, widthDiff, heightDiff) {
        /// <history>
        /// <entry mat="[GBAU]" date="29/11/2012" task="58867">Création</entry>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Modification</entry>
        /// <history>

        if (width !== false) {
            this.getJQueryElement().width(width);
        }
        if (height !== false) {
            this.getJQueryElement().height(height);
        }
    }
    buildAjaxUrl(url) {
        url = addParamToUrl(url, "componentId", this.serverId);
        url = addParamToUrl(url, "vsId", uiCore.componentManager.getViewstateId());
        if (this._instanceType) {
            url = addParamToUrl(url, "instanceType", this._instanceType);
        }
        return uiCore.buildAjaxUrl(url);
    }
    buildAjaxHandlerUrl(action, accept?, baseUrl?) {
        /// <summary>
        /// Cette fonction construit l'url d'acces a la ressource ASHX du composant, avec l'action précisée
        /// </summary>
        /// <param name="width">La largeur. Si false est passé, la largeur n'est pas modifiée.</param>
        /// <history>
        /// LBRI - 25/03/2014 - DEV84017
        /// <history>

        return this.buildAjaxUrl(uiCore.buildAjaxHandlerUrl(this.get_HttpHandlerUrl(), action, accept, baseUrl));
    }
    buildAjaxHandlerPostObject() {
        /// <summary>
        /// Cette fonction construit l'objet posté par le handler.
        /// </summary>
        /// <history>
        /// LBRI - 04/04/2014 - DEV84018
        /// <history>
        return {
            __type: "IsiDtoHttpHandlerRequest:#Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers",
            data: {

            }
        };
    }
    declareEvent(name) {
        /// <summary>
        /// Permet de déclarer un évènement dans le composant (a faire dans le initialize)
        /// </summary>
        /// <param name="name">Nom de l'évènement.</param>
        /// <history>
        /// LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        /// <history>
        var e = new window.IsiFW.IsiComponentEvent(name);
        this.events[name] = e;
        return e;
    }
    declareAjaxEvent(name, httpMethod, url) {
        /// <summary>
        /// Permet de déclarer un évènement AJAX dans le composant (a faire dans le initialize)
        /// </summary>
        /// <param name="name">Nom de l'évènement.</param>
        /// <param name="httpMethod">Méthode HTTP à utiliser (GET,POST).</param>
        /// <param name="url">Url.</param>
        /// <history>
        /// LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        /// <history>
        if (!url && this.get_HttpHandlerUrl()) {
            url = this.buildAjaxHandlerUrl(name);
        }
        var e = new window.IsiComponentAjaxEvent(name, httpMethod, url);
        this.events[name] = e;
        return e;
    }
    getEvent(name) {
        /// <summary>
        /// Permet de récupérer un évènement par son nom
        /// </summary>
        /// <param name="name">Nom de l'évènement.</param>
        /// <history>
        /// LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        /// <history>
        return this.events[name];
    }
    startPerfCounter(id) {
        this._perfCounters[id] = { start: new Date().getTime() };
    }
    stopPerfCounter(id) {
        var counter;
        counter = this._perfCounters[id];
        if (counter) {
            counter.ellapsed = new Date().getTime() - counter.start;

            this._PerfCountersChange();
        }
    }
    getPerfCounter(id) {
        return this._perfCounters[id];
    }
    getPerfCounters(id) {
        return this._perfCounters;
    }
    add_PerfCountersChange(handler) {
        this.addEventHandler("PerfCountersChange", handler);
    }
    remove_PerfCountersChange(handler) {
        this.removeEventHandler("PerfCountersChange", handler);
    }
    _PerfCountersChange(sender?, args?) {
        this._onPerfCountersChange(sender, args);
        this.raiseEvent("PerfCountersChange", this._perfCounters);
    }
    _onPerfCountersChange(sender, args) {

    }
    getTranslations() {
        return this._translations;
    }
    /**
     * Obtient une traduction à partir de sont id. Si la traduction n'est pas trouvée, elle retourne la clé.
     */
    getTranslation(key, defaultValue) {
        var translation;
        if (typeof defaultValue == "undefined") {
            defaultValue = key;
        }
        if (this.getTranslations() && this.getTranslations().Default) {
            translation = this.getTranslations().Default[key];
        }
        translation = translation || defaultValue;
        return translation;
    }
    getStateId() {
        return this.getId() + "state";
    }
    /**
     * Retourne l'etat du composant
     */
    saveState() {
        return this._saveStateOverridable();
    }
    /**
     * Méthode à surcharger au niveau du composant pour gérer la sauvegarde de l'état
     * @returns {Object} L'objet représentant l'état du composant
     */
    _saveStateOverridable() {
        return null;
    }
    /**
     * Créé une instance vide du state du composant
     * Cette méthode est à surcharger au niveau du composant pour avoir un objet state spécifique
     **/
    protected _createInstanceOfStateOverridable(): IsiComponentClientState<IsiDtoComponentClientState> {
        return new IsiComponentClientState<IsiDtoComponentClientState>(IsiDtoComponentClientState.fromJS);
    }

    loadState(state: IsiDtoComponentClientState) {
        this._state.loadObject(state);
        this._loadState();
    }

    /**
     * Déclenche la restauration de l'état
     * @returns {Boolean}
     */
    protected _loadStateHimself() {
        if (window.isiSessionStorage) {
            var serializedState = window.isiSessionStorage.getItem(this.getStateId());
            if (serializedState && serializedState !== "false") {
                this._state.loadSerialized(serializedState);
                this._loadState();
            }
            if (!this.getDto().keepState) this.clearState();
        }

        return true;
    }

    /**
     * Méthode à surcharger au niveau du composant pour gérer la restauration de l'état
     * @param {Object} state L'état qui à été précédemment sauvegardé
     * @returns {Boolean}
     */
    protected _loadState() {
        this._loadStateOverridable();
        this._stateLoaded();
    }

    /**
     * Méthode à surcharger au niveau du composant pour gérer la restauration de l'état
     * @param {Object} state L'état qui à été précédemment sauvegardé
     * @returns {Boolean}
     */
    protected _loadStateOverridable() {

    }

    /**
     * Suppression de l'état du composant
     * @returns {Boolean}
     */
    clearState(clearObject?) {
        if (this.getDto().saveClientStateResponsible == SaveClientStateResponsibleValue.Himself) {
            window.isiSessionStorage.setItem(this.getStateId(), false);
        }
        if (clearObject) {
            this._state = this._createInstanceOfStateOverridable();
            this._stateCleared();
        }
        return true;
    }

    getState() {
        return this._state;
    }
    /**
     * Indique si un état à été restauré
     * @returns {Boolean} true si un état précédent a été restauré sinon false
     */
    _stateRestored() {
        return this._state.isLoaded;
    }
    add_onInitialized(handler) {
        this.addEventHandler("onInitialized", handler);
    }
    remove_onInitialized(handler) {
        this.removeEventHandler("onInitialized", handler);
    }
    _onInitialized(sender, args) {
        //GBAU - 03/11/2016 - RWD DEV127803
        this._isInitialized = true;
        this.raiseEvent("onInitialized", args);
        return true;
    }
    initialized(handler) {
        if (this._isInitialized) {
            handler(this, {});
        } else {
            this.add_onInitialized(handler);
        }
    }
    /**
     * Abonnement sur l'évènement loading du composant
     * @param {Function} handler La fonction à abonner
     */
    add_onLoading(handler) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.addEventHandler("onLoading", handler);
    }
    /**
     * Suppression de l'abonnement à l'évènement loading du composant
     * @param {Function} handler La fonction à désabonner
     */
    remove_onLoading(handler) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.removeEventHandler("onLoading", handler);
    }
    /**
     * Déclenchement de l'évènement loading
     * @param {IsiFW.IsiComponent} sender Le composant
     * @param {Object} args Les arguments de l'évènement
     */
    _onLoading(sender?, args?) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.raiseEvent("onLoading", args);
        return true;
    }
    /**
     * Abonnement sur l'évènement loaded du composant
     * @param {Function} handler La fonction à abonner
     */
    add_loaded(handler) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.addEventHandler("loaded", handler);
    }
    /**
     * Suppression de l'abonnement à l'évènement loaded du composant
     * @param {Function} handler La fonction à désabonner
     */
    remove_loaded(handler) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.removeEventHandler("loaded", handler);
    }
    /**
     * Déclenchement de l'évènement loaded
     * @param {IsiFW.IsiComponent} sender Le composant
     * @param {Object} args Les arguments de l'évènement
     */
    _loaded(sender?, args?) {
        /// <history>
        /// <entry mat="[GBAU]" date="06/02/2017" bug="78515">Création</entry>
        /// <history>
        this.raiseEvent("loaded", args);
        return true;
    }
    _isAutoHeight() {
        return this.getJQueryElement().hasClass("autoHeight");
    }
    _bindHeaderEvents() {
        this.whenChildFound("Header", function (me) {
            return function (header) {
                me._header = header;
                me._header.add_onHidden(function (sender, args) {
                    if (!me._isWrapper()) {
                        me.hide();
                    }
                });
            }
        }(this));
    }
    _isWrapper() {
        return this.get_ChildId() && this.get_ChildId().toLowerCase() == "wrapper";
    }
    visibilityChange() {
    }
    _getHiddenFieldValue(id) {
        return jQuery("#" + this.getId(true) + "_" + id).val();
    }
    _setHiddenFieldValue(id, value) {
        jQuery("#" + this.getId(true) + "_" + id).val(JSON.stringify(value));
    }
    /**
     * Vérouille le scroll sur le body (utiliser quand la IsiPopin est affichée)
     * @author MBRO
     * @date 25/09/2018 10:47:21
     * @dysf 84180
     */
    _lockBodyScroll() {
        if (window.pageYOffset) {
            // Si un scroll est actuellement présent on le sauvegarde
            this._scrollTop = window.pageYOffset;
        } else {
            this._scrollTop = 0;
        }

        if (uiCore.browser.isSafari()) {
            // Sous Safari l'ouverture du clavier virtuel provoque un déplacement du contenu de la page vers le haut.
            // Pour compenser il faut 'scroller' tout en haut de la page
            // MAIS il faut attendre 300ms pour que la barre de navigation passe de sa hauteur réduite à sa hauteur standard
            // (fonctionnalité iOS pour que la barre de navigation prenne mois de place pendant un scroll sur une page).
            window.setTimeout(function () {
                window.scrollTo(0, 0);
            }, 300);
        }

        // On empêche le scroll sur le document via css
        jQuery("body").css({
            position: "fixed",
            overflow: "hidden",
            top: -this._scrollTop
        });
    }
    /**
     * Dévérouille le scroll sur le body (utiliser quand la IsiPopin est masquée)
     * @author MBRO
     * @date 25/09/2018 10:47:21
     * @dysf 84180
     */
    _unlockBodyScroll() {
        // On retire le css empêchant le scroll du body
        jQuery("body").css({
            position: "",
            overflow: "",
            top: ""
        });

        // On se repositionnement sur la fenêtre au niveau de scroll avant l'affichage de la popin
        window.scrollTo(0, this._scrollTop);
        window.setTimeout(function () {
            this._scrollTop = null;
        }, 0);
    }

    updateDtoProperty(property, value) {
        updateDtoProperty(this.get_Dto(), property, value);
    }
    updateConfiguration(property, value) {
        this.updateDtoProperty(property, value);
    }
    _getDtoTypeOverridable() {
        return null;
    }

    _createInstanceOfDtoOverridable(value: IIsiDtoComponentV4) {
        return IsiDtoComponentV4.fromJS(value);
    }

    /**
     * Retourne si la sauvegarde de l'état client est activée
     * */
    isStateEnabled() {
        return this.getDto().saveClientState;
    }

    /**
     * Retourne si l'état du composant doit être conservé
     */
    isKeepedState() {
        return this.getDto().keepState;
    }

    /**
    * Retourne si l'état client est en mode serveur
    * */
    isStateModeServer() {
        return this.getDto().stateMode == StateModeValue.Server;
    }

    /**
    * Retourne si l'état client est en mode client
    * */
    isStateModeClient() {
        return this.getDto().stateMode == StateModeValue.Client;
    }

    /**
    * Retourne si le composant gère lui même son etat client
    * */
    isStateResponsibleHimself() {
        return this.getDto().saveClientStateResponsible == SaveClientStateResponsibleValue.Himself;
    }

    /**
    * Retourne si la sauvegarde de l'état client est activée et si le composant gère lui même son etat client
    * */
    isStateHimselfEnabled() {
        return this.isStateResponsibleHimself() && this.isStateEnabled();
    }

    /**
    * Retourne si l'état client est en mode serveur et si le composant gère lui même son etat client
    * */
    isStateServerHimself() {
        return this.isStateModeServer() && this.isStateResponsibleHimself();
    }


    /**
    * Retourne si l'état client est en mode client et si le composant gère lui même son etat client
    * */
    isStateClientHimself() {
        return this.isStateModeClient() && this.isStateResponsibleHimself();
    }

}
